import React from 'react';
import { NotifyModal } from '@common/components/NotifyModal';
import { Button, ButtonTypes } from '@common/components';
import Divider from '@common/components/Divider/Divider';
import * as Styled from './styles';
import { DuplicateProductErrorMode, IModalProps } from './types';

const getFieldLabel = (conflictField?: string) =>
  conflictField === 'medicinalProductName' ? 'a Medicinal Product Name' : 'an emc Display Name';

const getCloseButtonText = (canViewProduct: boolean) => (canViewProduct ? 'Cancel' : 'Close');

const ViewProductButton = ({ onProductView }: { onProductView: () => void }) => (
  <>
    <Divider type="vertical" size="50px" thickness={1} />
    <Button onClick={onProductView} text="View product" type={ButtonTypes.PRIMARY} data-testid="view-product-button" />
  </>
);

const CreateModeContent = ({ productName, canViewProduct, conflictField }: { productName: string; canViewProduct: boolean; conflictField?: string }) => {
  const fieldLabel = getFieldLabel(conflictField);
  const bottomText = canViewProduct
    ? `Already exists as ${fieldLabel} in Publisher. Would you like to view it?`
    : `Already exists as ${fieldLabel} in a pending submission.`;
  return (
    <>
      <Styled.Text>The product you have created:</Styled.Text>
      <Styled.ProductName>{productName}</Styled.ProductName>
      <Styled.Text>{bottomText}</Styled.Text>
    </>
  );
};

const UpdateModeContent = ({ productName, canViewProduct, conflictField }: { productName: string; canViewProduct: boolean; conflictField?: string }) => {
  const fieldLabel = getFieldLabel(conflictField);
  const location = canViewProduct ? 'in Publisher. Would you like to view it?' : 'in a pending submission.';
  return (
    <Styled.Text>
      {'The product name '}
      <strong>{productName}</strong>
      {` already exists as ${fieldLabel} ${location}`}
    </Styled.Text>
  );
};

export const DuplicateProductError = ({ isOpen, productName, mode = DuplicateProductErrorMode.Create, onClose, onProductView, conflictField }: IModalProps) => {
  const canViewProduct = !!onProductView;

  return (
    <NotifyModal title={'Duplicate product'} isOpen={isOpen} data-testid="duplicate-product-error">
      <Styled.ErrorContent>
        {mode === DuplicateProductErrorMode.Update ? (
          <UpdateModeContent productName={productName} canViewProduct={canViewProduct} conflictField={conflictField} />
        ) : (
          <CreateModeContent productName={productName} canViewProduct={canViewProduct} conflictField={conflictField} />
        )}
      </Styled.ErrorContent>
      <Styled.ModalButtons>
        <Button onClick={onClose} text={getCloseButtonText(canViewProduct)} type={ButtonTypes.TEXT} data-testid="cancel-button" />
        {onProductView && <ViewProductButton onProductView={onProductView} />}
      </Styled.ModalButtons>
    </NotifyModal>
  );
};
